// src/pages/DoctorDashboard.js
import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import {
  Calendar,
  Users,
  Video,
  MessageCircle,
  CheckCircle2,
  Clock,
  Menu,
  X,
  ChevronDown,
  ChevronRight,
  Plus,
  Search,
  Filter,
  Bell,
  LogOut,
  User,
  Settings,
  ArrowLeft,
  FileText,
  Save,
  Mic,
  MicOff,
  VideoOff,
  Check,
  Brain,
  Lightbulb,
  Camera,
  Mail,
  Phone as PhoneIcon,
  Award,
  Shield,
  Trash2,
  ArrowRight,
  Info,
  Phone,
} from "lucide-react";
import quantumLogo from "../../quantum-care-logo.png";
import Nurseimg from "../../nurse.png";
import Register from "../Login/Register";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../CommonComponents/Select";
import { Context } from "../../CommonComponents/Wrapper";

function NurseDashboard() {
  const Navigate = useNavigate();
  const [showRegisterModal, setShowRegisterModal] = useState(false);
  const { locale, selectLang } = useContext(Context);
  const [language, setLanguage] = useState("en-US");
  const [showAssignSuccess, setShowAssignSuccess] = useState(false);
  const doctor = {
    name: "John Doe",
    specialty: "Nurse",
    avatar: Nurseimg,
  };

  const allAppointments = [
    {
      id: "APT-1001",
      patient: "Ahmed Hassan",
      cardno: "QCHC1234",
      avatar:
        "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
      date: "2025-08-20",
      time: "10:00 AM",
      type: "video",
      status: "upcoming",
      notes: "Follow-up for blood pressure",
      patientDetails: {
        name: "Ahmed Hassan",
        age: 29,
        sex: "Male",
        phone: "+960 123 4567",
        email: "ahmed.hassan@example.mv",
      },
      aiDiagnosis:
        "Patient presents with moderate seasonal allergy symptoms including runny nose, sneezing, and watery eyes. Symptoms started 5 days ago and have been progressively worsening. No fever reported. Patient has a history of similar seasonal allergic reactions. Physical examination reveals mild nasal congestion and slightly reddened eyes. Recommended antihistamine treatment.",
    },
    {
      id: "APT-1002",
      patient: "Aisha Ibrahim",
      cardno: "QCHC1235",
      avatar:
        "https://images.unsplash.com/photo-1580489944761-15a19d654956?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
      date: "2025-08-18",
      time: "02:30 PM",
      type: "chat",
      status: "upcoming",
      notes: "Medication review",
      patientDetails: {
        name: "Aisha Ibrahim",
        age: 34,
        sex: "Female",
        phone: "+960 987 6543",
        email: "aisha.ibrahim@example.mv",
      },
      aiDiagnosis:
        "Patient reports ongoing hypertension management. Current medication regimen appears to be working well with blood pressure readings within normal range. No significant side effects reported.",
    },
    {
      id: "APT-0998",
      patient: "Mohamed Ali",
      cardno: "QCHC1236",
      avatar:
        "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
      date: "2025-08-12",
      time: "11:15 AM",
      type: "video",
      status: "completed",
      notes: "Seasonal allergies",
      patientDetails: {
        name: "Mohamed Ali",
        age: 41,
        sex: "Male",
        phone: "+960 456 7890",
        email: "mohamed.ali@example.mv",
      },
      aiDiagnosis:
        "Patient presented with classic symptoms of seasonal allergies. Treatment with antihistamines was successful. Symptoms have significantly improved.",
    },
    {
      id: "APT-0997",
      patient: "Sarah Thomson",
      cardno: "QCHC1237",
      avatar:
        "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
      date: "2025-08-11",
      time: "09:45 AM",
      type: "video",
      status: "completed",
      notes: "General check-up",
      patientDetails: {
        name: "Sarah Thomson",
        age: 28,
        sex: "Female",
        phone: "+960 321 0987",
        email: "sarah.thomson@example.mv",
      },
      aiDiagnosis:
        "Routine health check-up completed. All vital signs within normal limits. Patient reports good overall health with no concerns.",
    },
  ];
  function AddPatientModal({ onClose, onAdd }) {
    const [form, setForm] = React.useState({
      firstName: "",
      lastName: "",
      mobile: "",
      email: "",
      dob: "",
      govId: "",
      password: "",
      confirmPassword: "",
    });
    const [error, setError] = React.useState("");

    function handleChange(e) {
      setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
      setError("");
    }

    function handleSubmit(e) {
      e.preventDefault();
      if (
        !form.firstName ||
        !form.lastName ||
        !form.mobile ||
        !form.email ||
        !form.dob ||
        !form.govId ||
        !form.password ||
        !form.confirmPassword
      ) {
        setError("All fields are required.");
        return;
      }
      if (form.password !== form.confirmPassword) {
        setError("Passwords do not match.");
        return;
      }
      onAdd(form);
      onClose();
    }

    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
        <form
          onSubmit={handleSubmit}
          className="bg-white max-w-lg w-full rounded-2xl shadow-2xl p-8 space-y-4"
        >
          <h2 className="text-2xl font-extrabold text-teal-700 mb-2">
            Add New Patient
          </h2>
          {error && <div className="text-red-600 text-sm">{error}</div>}
          <div className="grid grid-cols-2 gap-3">
            <input
              name="firstName"
              className="input"
              placeholder="First Name"
              value={form.firstName}
              onChange={handleChange}
            />
            <input
              name="lastName"
              className="input"
              placeholder="Last Name"
              value={form.lastName}
              onChange={handleChange}
            />
            <input
              name="mobile"
              className="input"
              placeholder="Mobile"
              value={form.mobile}
              onChange={handleChange}
            />
            <input
              name="email"
              className="input"
              placeholder="Email"
              value={form.email}
              onChange={handleChange}
            />
            <input
              name="dob"
              type="date"
              className="input"
              placeholder="DOB"
              value={form.dob}
              onChange={handleChange}
            />
            <input
              name="govId"
              className="input"
              placeholder="Govt ID Number"
              value={form.govId}
              onChange={handleChange}
            />
            <input
              name="password"
              type="password"
              className="input"
              placeholder="Password"
              value={form.password}
              onChange={handleChange}
            />
            <input
              name="confirmPassword"
              type="password"
              className="input"
              placeholder="Confirm Password"
              value={form.confirmPassword}
              onChange={handleChange}
            />
          </div>
          <div className="flex justify-end gap-3 pt-3">
            <button
              type="submit"
              className="px-6 py-2 rounded-lg bg-teal-600 text-white font-semibold hover:bg-teal-700"
            >
              Add Patient
            </button>
            <button
              type="button"
              onClick={onClose}
              className="px-6 py-2 rounded-lg bg-gray-100 text-gray-700 hover:bg-gray-200"
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    );
  }

  //Create Appointment Modal
  function CreateAppointmentModal({
    onClose,
    onAdd,
    patients,
    doctors,
    type,
    onNavigate,
    onCreate,
    selectedAppointment = null,
  }) {
    // Get current date and time as defaults
    const getCurrentDateTime = () => {
      const now = new Date();
      const currentDate = now.toISOString().split("T")[0]; // YYYY-MM-DD format
      return { currentDate };
    };

    // Fixed function to get nearest time slot in correct format
    const getNearestTimeSlot = () => {
      const timeSlots = [
        "09:00 AM",
        "09:30 AM",
        "10:00 AM",
        "10:30 AM",
        "11:00 AM",
        "11:30 AM",
        "12:00 PM",
        "12:30 PM",
        "01:00 PM",
        "01:30 PM",
        "02:00 PM",
        "02:30 PM",
        "03:00 PM",
        "03:30 PM",
        "04:00 PM",
        "04:30 PM",
        "05:00 PM",
      ];

      const now = new Date();
      let hour = now.getHours();
      let minute = now.getMinutes();

      // Round to next 30 minute slot
      if (minute > 30) {
        hour += 1;
        minute = 0;
      } else if (minute > 0) {
        minute = 30;
      }

      // Convert to 12-hour format
      let ampm = hour >= 12 ? "PM" : "AM";
      let hour12 = hour % 12;
      hour12 = hour12 === 0 ? 12 : hour12;

      // Format the time string to match timeSlots format
      const formattedTime = `${hour12.toString().padStart(2, "0")}:${minute
        .toString()
        .padStart(2, "0")} ${ampm}`;

      // Find the next available slot or default to first slot
      const nextSlot = timeSlots.find((slot) => slot >= formattedTime);
      return nextSlot || timeSlots[0];
    };

    const { currentDate } = getCurrentDateTime();

    const [form, setForm] = React.useState({
      patientSearch:
        type === "assign" && selectedAppointment
          ? selectedAppointment.patientDetails.name
          : "",
      doctorId: "",
      date: currentDate, // Auto-fill current date
      timeSlot: getNearestTimeSlot(), // Auto-fill nearest time slot with correct format
    });

    const [error, setError] = React.useState("");

    // Sample doctors data
    const sampleDoctors = [
      { id: 1, name: "Dr. Sarah Johnson", specialty: "Cardiologist" },
      { id: 2, name: "Dr. Michael Chen", specialty: "Neurologist" },
      { id: 3, name: "Dr. Emily Davis", specialty: "Pediatrician" },
      { id: 4, name: "Dr. James Wilson", specialty: "Orthopedic Surgeon" },
      { id: 5, name: "Dr. Maria Rodriguez", specialty: "Dermatologist" },
    ];

    const timeSlots = [
      "09:00 AM",
      "09:30 AM",
      "10:00 AM",
      "10:30 AM",
      "11:00 AM",
      "11:30 AM",
      "12:00 PM",
      "12:30 PM",
      "01:00 PM",
      "01:30 PM",
      "02:00 PM",
      "02:30 PM",
      "03:00 PM",
      "03:30 PM",
      "04:00 PM",
      "04:30 PM",
      "05:00 PM",
    ];

    function handleChange(e) {
      setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
      setError("");
    }

    function handleSubmit(e) {
      e.preventDefault();

      if (!form.patientSearch) {
        setError("Patient name is required.");
        return;
      }

      // Create a mock appointment object for selectedAppointment
      const newAppointment = {
        id: `APT-${Date.now()}`,
        patient: form.patientSearch,
        cardno: "QCHC" + Math.floor(Math.random() * 10000),
        avatar:
          "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
        date: form.date,
        time: form.timeSlot,
        type: "video",
        status: "upcoming",
        notes:
          type === "assign" ? "Doctor assigned" : "New appointment created",
        patientDetails: {
          name: form.patientSearch,
          age: 30,
          sex: "Male",
          phone: "+960 123 4567",
          email: "patient@example.mv",
        },
        aiDiagnosis: "New appointment - no diagnosis available yet.",
      };

      // If onAdd is provided, call it
      if (onAdd) {
        onAdd({
          ...form,
          patientId: form.patientSearch,
        });
      }

      // Close modal first
      onClose();

      // Call onCreate to trigger navigation and set selected appointment
      if (onCreate) {
        onCreate(newAppointment);
      }

      if (type === "assign") {
        setShowAssignSuccess(true);
      }
    }

    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
        <form
          onSubmit={handleSubmit}
          className="bg-white max-w-lg w-full rounded-2xl shadow-2xl p-8 space-y-4"
        >
          <h2 className="text-2xl font-extrabold text-teal-700 mb-2">
            {type === "create" ? "Create Appointment" : "Assign Doctor"}
          </h2>
          {error && <div className="text-red-600 text-sm">{error}</div>}

          <div className="grid grid-cols-2 gap-3">
            <div className="col-span-2">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Patient Name *
              </label>
              <input
                name="patientSearch"
                type="text"
                value={form.patientSearch}
                required
                onChange={handleChange}
                placeholder={
                  type === "create"
                    ? "Enter patient name or health card no"
                    : "Patient name (auto-filled)"
                }
                className="input w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-teal-400 focus:border-transparent"
                readOnly={type === "assign"}
                style={{
                  backgroundColor: type === "assign" ? "#f9fafb" : "white",
                }}
              />
              {type === "assign" && (
                <p className="text-xs text-gray-500 mt-1">
                  Patient information auto-filled from appointment
                </p>
              )}
            </div>

            <div className="col-span-2">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Select Doctor
              </label>
              <select
                name="doctorId"
                value={form.doctorId}
                onChange={handleChange}
                className="input w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-teal-400 focus:border-transparent"
              >
                <option value="">-- Select Doctor --</option>
                {sampleDoctors.map((d) => (
                  <option key={d.id} value={d.id}>
                    {d.name} - {d.specialty}
                  </option>
                ))}
              </select>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Date
              </label>
              <input
                name="date"
                type="date"
                value={form.date}
                onChange={handleChange}
                className="input w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-teal-400 focus:border-transparent"
              />
              <p className="text-xs text-gray-500 mt-1">
                Default: Today's date ({form.date})
              </p>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Time Slot
              </label>
              <select
                name="timeSlot"
                value={form.timeSlot}
                onChange={handleChange}
                className="input w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-teal-400 focus:border-transparent"
              >
                <option value="">-- Select Time Slot --</option>
                {timeSlots.map((ts) => (
                  <option key={ts} value={ts}>
                    {ts}
                  </option>
                ))}
              </select>
              <p className="text-xs text-gray-500 mt-1">
                Default: Next available slot ({form.timeSlot})
              </p>
            </div>
          </div>

          <div className="flex justify-end gap-3 pt-3">
            <button
              type="submit"
              className="px-6 py-2 rounded-lg bg-teal-600 text-white font-semibold hover:bg-teal-700"
            >
              {type === "create" ? "Create Appointment" : "Assign Doctor"}
            </button>
            <button
              type="button"
              onClick={onClose}
              className="px-6 py-2 rounded-lg bg-gray-100 text-gray-700 hover:bg-gray-200"
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    );
  }

  /* -------------------------------------------------------------------- */
  /*  ⬤  STATE                                                            */
  /* -------------------------------------------------------------------- */
  const [currentPage, setCurrentPage] = useState("home");
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [filter, setFilter] = useState("all");
  const [userDropdownOpen, setUserDropdownOpen] = useState(false);
  const [selectedAppointment, setSelectedAppointment] = useState(null);
  const [doctorNotes, setDoctorNotes] = useState("");
  const [prescription, setPrescription] = useState("");
  const [labTests, setLabTests] = useState("");
  const [showAddPatient, setShowAddPatient] = useState(false);
  const [showCreateApt, setShowCreateApt] = useState(false);
  const patientsArray = [];
  const doctorsArray = [];
  const [chatMessages, setChatMessages] = useState([]);
  const [symptoms, setSymptoms] = useState("");
  // Add referrals state to the main component
  const [referrals, setReferrals] = useState("");

  // Video call states
  const [isInWaitingRoom, setIsInWaitingRoom] = useState(false);
  const [isOnVideoCall, setIsOnVideoCall] = useState(false);
  const [callEnded, setCallEnded] = useState(false);

  // Video call handlers
  const handleJoinVideoCall = () => {
    setIsInWaitingRoom(false);
    setIsOnVideoCall(true);
    setCallEnded(false);
  };

  const handleEndCall = () => {
    setIsOnVideoCall(false);
    setCallEnded(true);
  };

  const handleCallEndedClose = () => {
    setCallEnded(false);
    setCurrentPage("appointments");
  };

  const startVideoCall = (appointment) => {
    setSelectedAppointment(appointment);
    setIsInWaitingRoom(true);
  };

  /* -------------------------------------------------------------------- */
  /*  ⬤  PRESCRIPTION COMPONENT                                           */
  /* -------------------------------------------------------------------- */
  const PrescriptionSection = ({ prescription, setPrescription }) => {
    const [rows, setRows] = useState([
      {
        id: Date.now(),
        drug: "",
        frequency: "",
        intake: "",
        duration: "",
        instructions: "",
      },
    ]);

    // Frequency options
    const frequencyOptions = [
      "Once Daily",
      "Twice Daily",
      "Thrice Daily",
      "Every 6 Hours",
      "Every 8 Hours",
      "Every 12 Hours",
      "As Needed",
    ];

    // Intake options
    const intakeOptions = [
      "Before Food",
      "After Food",
      "With Food",
      "Any Time",
    ];

    const addRow = () => {
      setRows((prev) => [
        ...prev,
        {
          id: Date.now(),
          drug: "",
          frequency: "",
          intake: "",
          duration: "",
          instructions: "",
        },
      ]);
    };

    const removeRow = (id) => {
      if (rows.length > 1) {
        setRows((prev) => prev.filter((row) => row.id !== id));
      }
    };

    const updateRow = (id, field, value) => {
      setRows((prev) =>
        prev.map((row) => (row.id === id ? { ...row, [field]: value } : row))
      );
    };

    // Generate prescription text for saving
    React.useEffect(() => {
      const presText = rows
        .map((row) => {
          const { drug, frequency, intake, duration, instructions } = row;
          if (!drug) return null;
          return `${drug} - ${frequency} - ${intake} - ${duration} day(s)${
            instructions ? ` - ${instructions}` : ""
          }`;
        })
        .filter(Boolean)
        .join("\n");
      setPrescription(presText);
    }, [rows, setPrescription]);

    return (
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Prescription
        </label>
        <div className="border border-gray-300 rounded-lg overflow-hidden">
          <table className="w-full text-sm">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-4 py-3 text-left font-medium text-gray-700 border-b">
                  Drugs
                </th>
                <th className="px-4 py-3 text-left font-medium text-gray-700 border-b">
                  Frequency
                </th>
                <th className="px-4 py-3 text-left font-medium text-gray-700 border-b">
                  Intake
                </th>
                <th className="px-4 py-3 text-left font-medium text-gray-700 border-b">
                  Duration
                </th>
                <th className="px-4 py-3 text-left font-medium text-gray-700 border-b">
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row, index) => (
                <tr
                  key={row.id}
                  className="border-b border-gray-200 last:border-b-0"
                >
                  <td className="px-4 py-3">
                    <input
                      type="text"
                      placeholder="Enter drug name"
                      value={row.drug}
                      onChange={(e) =>
                        updateRow(row.id, "drug", e.target.value)
                      }
                      className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-teal-400 focus:border-transparent"
                    />
                    {row.instructions && (
                      <div className="mt-1 text-xs text-gray-600 bg-gray-50 p-2 rounded">
                        Instructions: {row.instructions}
                      </div>
                    )}
                  </td>
                  <td className="px-4 py-3">
                    <select
                      value={row.frequency}
                      onChange={(e) =>
                        updateRow(row.id, "frequency", e.target.value)
                      }
                      className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-teal-400 focus:border-transparent"
                    >
                      <option value="">Frequency</option>
                      {frequencyOptions.map((opt) => (
                        <option key={opt} value={opt}>
                          {opt}
                        </option>
                      ))}
                    </select>
                    {/* <button
                      onClick={() => {
                        const instructions = prompt(
                          "Enter additional instructions:"
                        );
                        if (instructions) {
                          updateRow(row.id, "instructions", instructions);
                        }
                      }}
                      className="text-blue-600 mt-1 text-xs hover:underline"
                      type="button"
                    >
                      + Add Instructions
                    </button> */}
                  </td>
                  <td className="px-4 py-3">
                    <select
                      value={row.intake}
                      onChange={(e) =>
                        updateRow(row.id, "intake", e.target.value)
                      }
                      className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-teal-400 focus:border-transparent"
                    >
                      <option value="">Select intake</option>
                      {intakeOptions.map((opt) => (
                        <option key={opt} value={opt}>
                          {opt}
                        </option>
                      ))}
                    </select>
                  </td>
                  <td className="px-4 py-3">
                    <div className="flex items-center">
                      <input
                        type="number"
                        value={row.duration}
                        onChange={(e) =>
                          updateRow(row.id, "duration", e.target.value)
                        }
                        className="w-20 border border-gray-300 rounded-md px-3 py-2 text-sm mr-2 focus:outline-none focus:ring-2 focus:ring-teal-400 focus:border-transparent"
                        min="0"
                        placeholder="0"
                      />
                      <span className="text-sm text-gray-600">Day(s)</span>
                    </div>
                  </td>
                  <td className="px-4 py-3">
                    {index === 0 ? (
                      <button
                        onClick={addRow}
                        type="button"
                        className="inline-flex items-center px-3 py-1 rounded-md bg-green-50 border border-green-200 text-sm text-green-700 hover:bg-green-100 transition-colors"
                      >
                        <Plus className="w-4 h-4 mr-1" />
                        Add Row
                      </button>
                    ) : (
                      <button
                        onClick={() => removeRow(row.id)}
                        type="button"
                        className="inline-flex items-center px-3 py-1 rounded-md bg-red-50 border border-red-200 text-sm text-red-700 hover:bg-red-100 transition-colors"
                      >
                        <Trash2 className="w-4 h-4" />
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  /* -------------------------------------------------------------------- */
  /*  ⬤  LAB TESTS COMPONENT                                              */
  /* -------------------------------------------------------------------- */
  const LabTestsSection = ({ labTests, setLabTests }) => {
    const [tests, setTests] = useState([
      { id: Date.now(), testName: "", urgency: "", notes: "", category: "" },
    ]);

    // Lab test categories
    const testCategories = [
      "Blood Tests",
      "Urine Tests",
      "Imaging",
      "Cardiology",
      "Pathology",
      "Microbiology",
      "Biochemistry",
      "Other",
    ];

    // Urgency levels
    const urgencyLevels = ["Routine", "Urgent", "ASAP", "Emergency"];

    // Common lab tests by category
    const commonTests = {
      "Blood Tests": [
        "Complete Blood Count (CBC)",
        "Blood Sugar (Glucose)",
        "Lipid Profile",
        "Liver Function Test (LFT)",
        "Kidney Function Test (KFT)",
        "Thyroid Function Test (TFT)",
        "HbA1c",
        "ESR",
        "CRP",
      ],
      "Urine Tests": [
        "Urine Routine & Microscopy",
        "Urine Culture",
        "24-hour Urine Collection",
        "Protein in Urine",
      ],
      Imaging: [
        "X-Ray Chest",
        "X-Ray Abdomen",
        "Ultrasound Abdomen",
        "CT Scan",
        "MRI",
        "ECG",
        "Echo",
      ],
      Cardiology: ["ECG", "Echocardiogram", "Stress Test", "Holter Monitor"],
      Pathology: ["Biopsy", "Pap Smear", "Fine Needle Aspiration"],
      Microbiology: [
        "Blood Culture",
        "Sputum Culture",
        "Stool Culture",
        "Wound Swab",
      ],
    };

    const addTest = () => {
      setTests((prev) => [
        ...prev,
        {
          id: Date.now(),
          testName: "",
          urgency: "",
          notes: "",
          category: "",
        },
      ]);
    };

    const removeTest = (id) => {
      if (tests.length > 1) {
        setTests((prev) => prev.filter((test) => test.id !== id));
      }
    };

    const updateTest = (id, field, value) => {
      setTests((prev) =>
        prev.map((test) =>
          test.id === id ? { ...test, [field]: value } : test
        )
      );
    };

    // Generate lab tests text for saving
    React.useEffect(() => {
      const testsText = tests
        .map((test) => {
          const { testName, urgency, notes, category } = test;
          if (!testName) return null;
          return `${testName} (${category}) - ${urgency}${
            notes ? ` - ${notes}` : ""
          }`;
        })
        .filter(Boolean)
        .join("\n");
      setLabTests(testsText);
    }, [tests, setLabTests]);

    return (
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Recommended Lab Tests
        </label>
        <div className="border border-gray-300 rounded-lg overflow-hidden">
          <div className="bg-gradient-to-r from-purple-50 to-indigo-50 px-4 py-3 border-b border-gray-200">
            <div className="flex items-center">
              <div className="w-6 h-6 bg-purple-100 rounded-full flex items-center justify-center mr-3">
                <span className="text-purple-600 text-sm">🧪</span>
              </div>
              <h4 className="text-sm font-semibold text-gray-800">
                Laboratory Investigations
              </h4>
            </div>
          </div>

          <div className="p-4 space-y-4">
            {tests.map((test, index) => (
              <div
                key={test.id}
                className="bg-gray-50 border border-gray-200 rounded-lg p-4"
              >
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-3">
                  {/* Category Selection */}
                  <div>
                    <label className="block text-xs font-medium text-gray-600 mb-1">
                      Test Category
                    </label>
                    <select
                      value={test.category}
                      onChange={(e) =>
                        updateTest(test.id, "category", e.target.value)
                      }
                      className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-transparent"
                    >
                      <option value="">Select category</option>
                      {testCategories.map((category) => (
                        <option key={category} value={category}>
                          {category}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* Urgency Level */}
                  <div>
                    <label className="block text-xs font-medium text-gray-600 mb-1">
                      Urgency Level
                    </label>
                    <select
                      value={test.urgency}
                      onChange={(e) =>
                        updateTest(test.id, "urgency", e.target.value)
                      }
                      className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-transparent"
                    >
                      <option value="">Select urgency</option>
                      {urgencyLevels.map((level) => (
                        <option key={level} value={level}>
                          {level}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                {/* Test Name */}
                <div className="mb-3">
                  <label className="block text-xs font-medium text-gray-600 mb-1">
                    Test Name
                  </label>
                  <div className="relative">
                    <input
                      type="text"
                      placeholder="Enter test name or select from suggestions below"
                      value={test.testName}
                      onChange={(e) =>
                        updateTest(test.id, "testName", e.target.value)
                      }
                      className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-transparent"
                    />
                  </div>

                  {/* Quick suggestions based on category */}
                  {test.category && commonTests[test.category] && (
                    <div className="mt-2">
                      <p className="text-xs text-gray-500 mb-1">
                        Common {test.category}:
                      </p>
                      <div className="flex flex-wrap gap-1">
                        {commonTests[test.category]
                          .slice(0, 6)
                          .map((commonTest) => (
                            <button
                              key={commonTest}
                              type="button"
                              onClick={() =>
                                updateTest(test.id, "testName", commonTest)
                              }
                              className="inline-flex items-center px-2 py-1 rounded-md bg-purple-100 text-purple-700 text-xs hover:bg-purple-200 transition-colors"
                            >
                              {commonTest}
                            </button>
                          ))}
                      </div>
                    </div>
                  )}
                </div>

                {/* Clinical Notes */}
                <div className="mb-3">
                  <label className="block text-xs font-medium text-gray-600 mb-1">
                    Clinical Notes (Optional)
                  </label>
                  <textarea
                    rows={2}
                    placeholder="Additional instructions or clinical reasoning..."
                    value={test.notes}
                    onChange={(e) =>
                      updateTest(test.id, "notes", e.target.value)
                    }
                    className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-transparent resize-none"
                  />
                </div>

                {/* Action Buttons */}
                <div className="flex justify-between items-center pt-2 border-t border-gray-200">
                  <div className="flex items-center text-xs text-gray-500">
                    <span className="w-2 h-2 bg-purple-400 rounded-full mr-2"></span>
                    Test #{index + 1}
                  </div>
                  <div className="flex space-x-2">
                    {index === 0 ? (
                      <button
                        onClick={addTest}
                        type="button"
                        className="inline-flex items-center px-3 py-1 rounded-md bg-green-50 border border-green-200 text-sm text-green-700 hover:bg-green-100 transition-colors"
                      >
                        <Plus className="w-4 h-4 mr-1" />
                        Add Test
                      </button>
                    ) : (
                      <button
                        onClick={() => removeTest(test.id)}
                        type="button"
                        className="inline-flex items-center px-3 py-1 rounded-md bg-red-50 border border-red-200 text-sm text-red-700 hover:bg-red-100 transition-colors"
                      >
                        <Trash2 className="w-4 h-4 mr-1" />
                        Remove
                      </button>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Quick Add Common Tests */}
          <div className="bg-gray-50 px-4 py-3 border-t border-gray-200">
            <p className="text-xs font-medium text-gray-600 mb-2">
              Quick Add Common Tests:
            </p>
            <div className="flex flex-wrap gap-2">
              {[
                "Complete Blood Count",
                "Blood Sugar",
                "Lipid Profile",
                "Urine R/M",
                "X-Ray Chest",
                "ECG",
              ].map((quickTest) => (
                <button
                  key={quickTest}
                  type="button"
                  onClick={() => {
                    const newTest = {
                      id: Date.now(),
                      testName: quickTest,
                      urgency: "Routine",
                      notes: "",
                      category: quickTest.includes("Blood")
                        ? "Blood Tests"
                        : quickTest.includes("Urine")
                        ? "Urine Tests"
                        : quickTest.includes("X-Ray") ||
                          quickTest.includes("ECG")
                        ? "Imaging"
                        : "Other",
                    };
                    setTests((prev) => [...prev, newTest]);
                  }}
                  className="inline-flex items-center px-2 py-1 rounded-md bg-white border border-gray-300 text-xs text-gray-700 hover:bg-gray-100 transition-colors"
                >
                  + {quickTest}
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  };

  /* -------------------------------------------------------------------- */
  /*  ⬤  VIDEO CALL COMPONENTS                                            */
  /* -------------------------------------------------------------------- */

  /* -------------------------------------------------------------------- */
  /*  ⬤  REFERRAL COMPONENT                                               */
  /* -------------------------------------------------------------------- */
  const ReferralSection = ({ referrals, setReferrals }) => {
    const [referralList, setReferralList] = useState([
      {
        id: Date.now(),
        specialty: "",
        doctorName: "",
        reason: "",
        urgency: "",
        notes: "",
      },
    ]);

    // Medical specialties
    const specialties = [
      "Cardiology",
      "Dermatology",
      "Endocrinology",
      "Gastroenterology",
      "Neurology",
      "Oncology",
      "Orthopedics",
      "Psychiatry",
      "Pulmonology",
      "Rheumatology",
      "Urology",
      "Gynecology",
      "Pediatrics",
      "Ophthalmology",
      "ENT (Ear, Nose, Throat)",
      "Nephrology",
      "Hematology",
      "Radiology",
      "Anesthesiology",
      "General Surgery",
    ];

    // Referral urgency levels
    const urgencyLevels = [
      "Routine",
      "Within 2 weeks",
      "Within 1 week",
      "Urgent (within 3 days)",
      "Emergency",
    ];

    // Common referral reasons by specialty
    const commonReasons = {
      Cardiology: [
        "Chest pain evaluation",
        "Hypertension management",
        "Heart murmur assessment",
        "Arrhythmia evaluation",
        "Coronary artery disease",
      ],
      Dermatology: [
        "Skin lesion evaluation",
        "Chronic skin condition",
        "Mole assessment",
        "Acne treatment",
        "Rash investigation",
      ],
      Endocrinology: [
        "Diabetes management",
        "Thyroid disorder",
        "Hormone imbalance",
        "Metabolic syndrome",
        "Weight management",
      ],
      Orthopedics: [
        "Joint pain evaluation",
        "Fracture assessment",
        "Back pain management",
        "Sports injury",
        "Arthritis treatment",
      ],
      Neurology: [
        "Headache evaluation",
        "Seizure assessment",
        "Memory concerns",
        "Tremor evaluation",
        "Numbness/tingling",
      ],
    };

    // Sample specialist doctors
    const specialistDoctors = {
      Cardiology: [
        "Dr. Sarah Ahmed (Cardiologist)",
        "Dr. Mohamed Hassan (Cardiac Surgeon)",
      ],
      Dermatology: [
        "Dr. Aisha Rahman (Dermatologist)",
        "Dr. Ibrahim Ali (Skin Specialist)",
      ],
      Endocrinology: [
        "Dr. Fatima Khan (Endocrinologist)",
        "Dr. Ahmed Naseem (Diabetes Specialist)",
      ],
      Orthopedics: [
        "Dr. Hassan Ibrahim (Orthopedic Surgeon)",
        "Dr. Mariyam Ali (Joint Specialist)",
      ],
      Neurology: [
        "Dr. Ali Hassan (Neurologist)",
        "Dr. Zara Ahmed (Brain Specialist)",
      ],
    };

    const addReferral = () => {
      setReferralList((prev) => [
        ...prev,
        {
          id: Date.now(),
          specialty: "",
          doctorName: "",
          reason: "",
          urgency: "",
          notes: "",
        },
      ]);
    };

    const removeReferral = (id) => {
      if (referralList.length > 1) {
        setReferralList((prev) =>
          prev.filter((referral) => referral.id !== id)
        );
      }
    };

    const updateReferral = (id, field, value) => {
      setReferralList((prev) =>
        prev.map((referral) =>
          referral.id === id ? { ...referral, [field]: value } : referral
        )
      );
    };

    // Generate referrals text for saving
    React.useEffect(() => {
      const referralsText = referralList
        .map((referral) => {
          const { specialty, doctorName, reason, urgency, notes } = referral;
          if (!specialty || !reason) return null;
          return `Refer to ${specialty}${
            doctorName ? ` (${doctorName})` : ""
          } - ${reason} - ${urgency}${notes ? ` - ${notes}` : ""}`;
        })
        .filter(Boolean)
        .join("\n");
      setReferrals(referralsText);
    }, [referralList, setReferrals]);

    return (
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Refer to Specialist Doctor
        </label>
        <div className="border border-gray-300 rounded-lg overflow-hidden">
          <div className="bg-gradient-to-r from-orange-50 to-amber-50 px-4 py-3 border-b border-gray-200">
            <div className="flex items-center">
              <div className="w-6 h-6 bg-orange-100 rounded-full flex items-center justify-center mr-3">
                <span className="text-orange-600 text-sm">👨‍⚕️</span>
              </div>
              <h4 className="text-sm font-semibold text-gray-800">
                Specialist Referrals
              </h4>
              <span className="ml-2 text-xs text-orange-600 bg-orange-100 px-2 py-1 rounded-full">
                For specialized care
              </span>
            </div>
          </div>

          <div className="p-4 space-y-4">
            {referralList.map((referral, index) => (
              <div
                key={referral.id}
                className="bg-gradient-to-r from-orange-25 to-amber-25 border border-orange-200 rounded-lg p-4"
              >
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-3">
                  {/* Specialty Selection */}
                  <div>
                    <label className="block text-xs font-medium text-gray-600 mb-1">
                      Medical Specialty *
                    </label>
                    <select
                      value={referral.specialty}
                      onChange={(e) =>
                        updateReferral(referral.id, "specialty", e.target.value)
                      }
                      className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-orange-400 focus:border-transparent"
                    >
                      <option value="">Select specialty</option>
                      {specialties.map((specialty) => (
                        <option key={specialty} value={specialty}>
                          {specialty}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* Urgency Level */}
                  <div>
                    <label className="block text-xs font-medium text-gray-600 mb-1">
                      Referral Priority *
                    </label>
                    <select
                      value={referral.urgency}
                      onChange={(e) =>
                        updateReferral(referral.id, "urgency", e.target.value)
                      }
                      className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-orange-400 focus:border-transparent"
                    >
                      <option value="">Select priority</option>
                      {urgencyLevels.map((level) => (
                        <option key={level} value={level}>
                          {level}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                {/* Preferred Doctor */}
                <div className="mb-3">
                  <label className="block text-xs font-medium text-gray-600 mb-1">
                    Preferred Specialist (Optional)
                  </label>
                  <div className="relative">
                    <input
                      type="text"
                      placeholder="Enter specific doctor name or leave blank for any available specialist"
                      value={referral.doctorName}
                      onChange={(e) =>
                        updateReferral(
                          referral.id,
                          "doctorName",
                          e.target.value
                        )
                      }
                      className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-orange-400 focus:border-transparent"
                    />
                  </div>

                  {/* Doctor suggestions based on specialty */}
                  {referral.specialty &&
                    specialistDoctors[referral.specialty] && (
                      <div className="mt-2">
                        <p className="text-xs text-gray-500 mb-1">
                          Available {referral.specialty} specialists:
                        </p>
                        <div className="flex flex-wrap gap-1">
                          {specialistDoctors[referral.specialty].map(
                            (doctor) => (
                              <button
                                key={doctor}
                                type="button"
                                onClick={() =>
                                  updateReferral(
                                    referral.id,
                                    "doctorName",
                                    doctor
                                  )
                                }
                                className="inline-flex items-center px-2 py-1 rounded-md bg-orange-100 text-orange-700 text-xs hover:bg-orange-200 transition-colors"
                              >
                                {doctor}
                              </button>
                            )
                          )}
                        </div>
                      </div>
                    )}
                </div>

                {/* Referral Reason */}
                <div className="mb-3">
                  <label className="block text-xs font-medium text-gray-600 mb-1">
                    Reason for Referral *
                  </label>
                  <input
                    type="text"
                    placeholder="Enter the primary reason for this referral"
                    value={referral.reason}
                    onChange={(e) =>
                      updateReferral(referral.id, "reason", e.target.value)
                    }
                    className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-orange-400 focus:border-transparent mb-2"
                  />

                  {/* Quick reasons based on specialty */}
                  {referral.specialty && commonReasons[referral.specialty] && (
                    <div>
                      <p className="text-xs text-gray-500 mb-1">
                        Common reasons for {referral.specialty}:
                      </p>
                      <div className="flex flex-wrap gap-1">
                        {commonReasons[referral.specialty].map((reason) => (
                          <button
                            key={reason}
                            type="button"
                            onClick={() =>
                              updateReferral(referral.id, "reason", reason)
                            }
                            className="inline-flex items-center px-2 py-1 rounded-md bg-amber-100 text-amber-700 text-xs hover:bg-amber-200 transition-colors"
                          >
                            {reason}
                          </button>
                        ))}
                      </div>
                    </div>
                  )}
                </div>

                {/* Clinical Notes */}
                <div className="mb-3">
                  <label className="block text-xs font-medium text-gray-600 mb-1">
                    Additional Notes for Specialist
                  </label>
                  <textarea
                    rows={3}
                    placeholder="Include relevant clinical findings, previous treatments tried, or specific questions for the specialist..."
                    value={referral.notes}
                    onChange={(e) =>
                      updateReferral(referral.id, "notes", e.target.value)
                    }
                    className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-orange-400 focus:border-transparent resize-none"
                  />
                </div>

                {/* Action Buttons */}
                <div className="flex justify-between items-center pt-2 border-t border-orange-200">
                  <div className="flex items-center text-xs text-gray-500">
                    <span className="w-2 h-2 bg-orange-400 rounded-full mr-2"></span>
                    Referral #{index + 1}
                    {referral.specialty && (
                      <span className="ml-2 text-orange-600 font-medium">
                        → {referral.specialty}
                      </span>
                    )}
                  </div>
                  <div className="flex space-x-2">
                    {index === 0 ? (
                      <button
                        onClick={addReferral}
                        type="button"
                        className="inline-flex items-center px-3 py-1 rounded-md bg-green-50 border border-green-200 text-sm text-green-700 hover:bg-green-100 transition-colors"
                      >
                        <Plus className="w-4 h-4 mr-1" />
                        Add Referral
                      </button>
                    ) : (
                      <button
                        onClick={() => removeReferral(referral.id)}
                        type="button"
                        className="inline-flex items-center px-3 py-1 rounded-md bg-red-50 border border-red-200 text-sm text-red-700 hover:bg-red-100 transition-colors"
                      >
                        <Trash2 className="w-4 h-4 mr-1" />
                        Remove
                      </button>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Quick Add Common Referrals */}
          <div className="bg-orange-50 px-4 py-3 border-t border-orange-200">
            <p className="text-xs font-medium text-gray-600 mb-2">
              Quick Add Common Referrals:
            </p>
            <div className="flex flex-wrap gap-2">
              {[
                { specialty: "Cardiology", reason: "Chest pain evaluation" },
                { specialty: "Dermatology", reason: "Skin lesion assessment" },
                { specialty: "Orthopedics", reason: "Joint pain evaluation" },
                { specialty: "Endocrinology", reason: "Diabetes management" },
              ].map((quickReferral) => (
                <button
                  key={`${quickReferral.specialty}-${quickReferral.reason}`}
                  type="button"
                  onClick={() => {
                    const newReferral = {
                      id: Date.now(),
                      specialty: quickReferral.specialty,
                      doctorName: "",
                      reason: quickReferral.reason,
                      urgency: "Routine",
                      notes: "",
                    };
                    setReferralList((prev) => [...prev, newReferral]);
                  }}
                  className="inline-flex items-center px-3 py-1 rounded-md bg-white border border-orange-300 text-xs text-orange-700 hover:bg-orange-100 transition-colors"
                >
                  + {quickReferral.specialty}: {quickReferral.reason}
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  };

  // Waiting Room Component
  const WaitingRoomPage = ({ onJoin }) => (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-6">
      <div className="bg-white rounded-xl shadow-lg max-w-md w-full p-8 text-center">
        <div className="mb-6">
          <svg
            className="animate-spin h-16 w-16 text-blue-600 mx-auto"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            ></circle>
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8v8H4z"
            ></path>
          </svg>
        </div>

        <h2 className="text-xl font-semibold text-gray-900 mb-2">
          Preparing consultation
        </h2>

        <p className="text-gray-600 mb-6">
          {selectedAppointment
            ? `Connecting with ${selectedAppointment.patient}`
            : "Connecting with patient"}
        </p>

        <div className="space-y-2 mb-6">
          <p className="text-gray-700">
            <span className="font-semibold">Appointment Time:</span>{" "}
            {selectedAppointment?.time}
          </p>
          <p className="text-gray-700">
            <span className="font-semibold">Patient:</span>{" "}
            {selectedAppointment?.patient}
          </p>
        </div>

        <button
          onClick={onJoin}
          className="bg-green-600 text-white px-6 py-3 rounded-lg flex items-center justify-center mx-auto hover:bg-green-700 transition-colors"
        >
          <Video className="h-6 w-6 mr-2" />
          Start Consultation
        </button>
      </div>
    </div>
  );

  // Video Call Component with Clear Images and AI Insights
  const VideoCallPage = ({ onEndCall }) => {
    const [micOn, setMicOn] = useState(true);
    const [videoOn, setVideoOn] = useState(true);

    return (
      <div className="min-h-screen bg-gray-100 p-6">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-2xl font-semibold mb-6 text-gray-900">
            Video Consultation with {selectedAppointment?.patient}
          </h2>

          <div className="grid lg:grid-cols-3 gap-8">
            {/* Video Section - 2/3 width */}
            <div className="lg:col-span-2">
              {/* Main Video Container with Clear Images */}
              <div className="relative rounded-xl overflow-hidden bg-black h-96 mb-6 shadow-lg">
                <img
                  src={
                    selectedAppointment?.avatar ||
                    "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
                  }
                  alt={selectedAppointment?.patient}
                  className="object-cover w-full h-full"
                  style={{
                    imageRendering: "auto",
                    filter: "contrast(1.1) brightness(1.05)",
                  }}
                />

                {/* Video Controls Overlay */}
                <div className="absolute bottom-6 left-1/2 transform -translate-x-1/2 flex items-center space-x-4 bg-black bg-opacity-70 rounded-full px-6 py-3">
                  <button
                    onClick={() => setMicOn(!micOn)}
                    className={`p-3 rounded-full transition-colors ${
                      micOn
                        ? "bg-blue-600 hover:bg-blue-700"
                        : "bg-red-600 hover:bg-red-700"
                    }`}
                    title={micOn ? "Mute Microphone" : "Unmute Microphone"}
                  >
                    {micOn ? (
                      <Mic className="h-6 w-6 text-white" />
                    ) : (
                      <MicOff className="h-6 w-6 text-white" />
                    )}
                  </button>

                  <button
                    onClick={() => setVideoOn(!videoOn)}
                    className={`p-3 rounded-full transition-colors ${
                      videoOn
                        ? "bg-green-600 hover:bg-green-700"
                        : "bg-red-600 hover:bg-red-700"
                    }`}
                    title={videoOn ? "Turn Off Video" : "Turn On Video"}
                  >
                    {videoOn ? (
                      <Video className="h-6 w-6 text-white" />
                    ) : (
                      <VideoOff className="h-6 w-6 text-white" />
                    )}
                  </button>

                  <button
                    onClick={onEndCall}
                    className="bg-red-600 hover:bg-red-700 text-white px-6 py-3 rounded-full font-semibold transition-colors"
                    title="End Call"
                  >
                    End Consultation
                  </button>
                </div>
              </div>

              {/* Local Doctor Video */}
              <div className="flex items-center space-x-4">
                <div className="relative rounded-lg overflow-hidden bg-black w-40 h-28 shadow-md">
                  <img
                    src={doctor.avatar}
                    alt="You"
                    className="object-cover w-full h-full"
                    style={{
                      imageRendering: "auto",
                      filter: "contrast(1.1) brightness(1.05)",
                    }}
                  />
                  <div className="absolute bottom-1 left-1 bg-black bg-opacity-70 text-white px-2 py-1 text-xs rounded">
                    You ({doctor.name.split(" ")[1]})
                  </div>
                </div>
                <div>
                  <p className="text-gray-700 font-medium">
                    Consultation in progress
                  </p>
                  <p className="text-gray-500 text-sm">
                    Patient: {selectedAppointment?.patient}
                  </p>
                </div>
              </div>
            </div>

            {/* AI Insights Sidebar - 1/3 width */}
            <div className="lg:col-span-1">
              <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-6 h-fit sticky top-6">
                <div className="flex items-center mb-4">
                  <div className="w-8 h-8 bg-teal-100 rounded-full flex items-center justify-center mr-3">
                    <Brain className="h-4 w-4 text-teal-600" />
                  </div>
                  <h3 className="text-lg font-semibold text-gray-900">
                    AI Insights
                  </h3>
                </div>

                {/* AI Initial Diagnosis */}
                <div className="mb-6">
                  <h4 className="text-sm font-semibold text-gray-700 mb-3">
                    Initial AI Analysis
                  </h4>
                  <div className="bg-gradient-to-r from-teal-50 to-blue-50 p-4 rounded-lg border border-teal-100">
                    <p className="text-gray-700 text-sm leading-relaxed">
                      {selectedAppointment?.aiDiagnosis ||
                        "No AI diagnosis available for this consultation."}
                    </p>
                  </div>
                </div>

                {/* Suggested Questions */}
                <div className="mb-6">
                  <div className="flex items-center mb-3">
                    <Lightbulb className="h-4 w-4 text-yellow-500 mr-2" />
                    <h4 className="text-sm font-semibold text-gray-700">
                      Suggested Questions
                    </h4>
                  </div>
                  <div className="space-y-2">
                    {[
                      "When did your symptoms first start?",
                      "Rate your discomfort level (1-10)?",
                      "Any medications taken recently?",
                      "Recent travel or allergen exposure?",
                      "Any other accompanying symptoms?",
                      "Family history of similar conditions?",
                    ].map((question, index) => (
                      <div
                        key={index}
                        className="text-sm text-gray-600 p-2 bg-gray-50 rounded border hover:bg-gray-100 cursor-pointer transition-colors"
                      >
                        • {question}
                      </div>
                    ))}
                  </div>
                </div>

                {/* Patient Details Quick View */}
                <div>
                  <h4 className="text-sm font-semibold text-gray-700 mb-3">
                    Patient Info
                  </h4>
                  <div className="space-y-2 text-sm">
                    <div className="flex justify-between">
                      <span className="text-gray-500">Age:</span>
                      <span className="text-gray-900">
                        {selectedAppointment?.patientDetails?.age}
                      </span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-500">Sex:</span>
                      <span className="text-gray-900">
                        {selectedAppointment?.patientDetails?.sex}
                      </span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-500">Time:</span>
                      <span className="text-gray-900">
                        {selectedAppointment?.time}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  // Call Ended Component
  const CallEndedPage = ({ onClose }) => (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-6">
      <div className="bg-white rounded-xl shadow-lg max-w-md w-full text-center p-8">
        <div className="mb-6">
          <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <Check className="h-8 w-8 text-green-600" />
          </div>
        </div>

        <h2 className="text-2xl font-semibold text-gray-900 mb-4">
          Consultation Completed
        </h2>
        <p className="text-gray-600 mb-8">
          Your consultation with {selectedAppointment?.patient} has ended
          successfully. Don't forget to add your notes and prescription.
        </p>

        <div className="space-y-3">
          <button
            onClick={() => {
              setCallEnded(false);
              setSelectedAppointment(selectedAppointment);
              setCurrentPage("appointmentDetails");
            }}
            className="w-full bg-blue-600 text-white py-3 px-6 rounded-lg hover:bg-blue-700 transition-colors font-medium"
          >
            Add Notes & Prescription
          </button>
          <button
            onClick={onClose}
            className="w-full bg-gray-100 text-gray-700 py-3 px-6 rounded-lg hover:bg-gray-200 transition-colors font-medium"
          >
            Return to Appointments
          </button>
        </div>
      </div>
    </div>
  );

  /* -------------------------------------------------------------------- */
  /*  ⬤  NEW PROFILE PAGE COMPONENT                                      */
  /* -------------------------------------------------------------------- */
  const ProfilePage = () => {
    // Mock doctor profile data
    const mockDoctor = {
      name: "John Doe",
      email: "john.doe@quantumcare.com",
      phone: "+960 112 3355",
      specialty: "Nurse",
      licenseNumber: "MED-2018-0012345",
      qualification: "General Nursing",
      experience: "10+ years",
      bio: "Dedicated healthcare professional with over 10 years of experience in general practice. Specialized in preventive care, chronic disease management, and patient-centered healthcare delivery.",
      avatar: doctor.avatar,
      workingHours: "Monday - Friday: 9:00 AM - 5:00 PM",
    };

    return (
      <div className="min-h-screen bg-gray-50">
        <Navigation />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-8">
            Profile & Settings
          </h1>

          <div className="grid md:grid-cols-3 gap-8">
            {/* Profile Info */}
            <div className="md:col-span-2 space-y-6">
              {/* Personal Information */}
              <div className="bg-white rounded-xl p-6 border border-gray-200 shadow-sm">
                <div className="flex items-center justify-between mb-6">
                  <h2 className="text-xl font-semibold text-gray-900">
                    Personal Information
                  </h2>
                  <button className="flex items-center text-teal-600 hover:text-teal-700">
                    <Camera className="h-4 w-4 mr-1" />
                    Change Photo
                  </button>
                </div>

                <div className="flex items-center space-x-6 mb-6">
                  <img
                    src={mockDoctor.avatar}
                    alt={mockDoctor.name}
                    className="h-24 w-24 rounded-full object-cover border-4 border-gray-100"
                  />
                  <div>
                    <h3 className="text-2xl font-bold text-gray-900">
                      {mockDoctor.name}
                    </h3>
                    <p className="text-teal-600 font-medium">
                      {mockDoctor.specialty}
                    </p>
                    <p className="text-sm text-gray-500 mt-1">
                      {mockDoctor.qualification}
                    </p>
                  </div>
                </div>

                <div className="grid md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Full Name
                    </label>
                    <input
                      type="text"
                      defaultValue={mockDoctor.name}
                      className="w-full bg-white border border-gray-300 rounded-lg px-4 py-3 text-gray-900 focus:outline-none focus:ring-2 focus:ring-teal-400"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Email Address
                    </label>
                    <input
                      type="email"
                      defaultValue={mockDoctor.email}
                      className="w-full bg-white border border-gray-300 rounded-lg px-4 py-3 text-gray-900 focus:outline-none focus:ring-2 focus:ring-teal-400"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Phone Number
                    </label>
                    <input
                      type="tel"
                      defaultValue={mockDoctor.phone}
                      className="w-full bg-white border border-gray-300 rounded-lg px-4 py-3 text-gray-900 focus:outline-none focus:ring-2 focus:ring-teal-400"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Medical License
                    </label>
                    <input
                      type="text"
                      defaultValue={mockDoctor.licenseNumber}
                      className="w-full bg-white border border-gray-300 rounded-lg px-4 py-3 text-gray-900 focus:outline-none focus:ring-2 focus:ring-teal-400"
                    />
                  </div>
                </div>

                <div className="mt-6">
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Professional Bio
                  </label>
                  <textarea
                    rows={4}
                    defaultValue={mockDoctor.bio}
                    className="w-full bg-white border border-gray-300 rounded-lg px-4 py-3 text-gray-900 focus:outline-none focus:ring-2 focus:ring-teal-400 resize-none"
                    placeholder="Tell patients about your experience and specializations..."
                  />
                </div>

                <button className="mt-6 px-6 py-3 bg-teal-600 text-white rounded-lg hover:bg-teal-700 transition-colors font-medium">
                  Save Changes
                </button>
              </div>

              {/* Professional Information */}
              <div className="bg-white rounded-xl p-6 border border-gray-200 shadow-sm">
                <h2 className="text-xl font-semibold text-gray-900 mb-6">
                  Professional Information
                </h2>

                <div className="grid md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Specialty
                    </label>
                    <select className="w-full bg-white border border-gray-300 rounded-lg px-4 py-3 text-gray-900 focus:outline-none focus:ring-2 focus:ring-teal-400">
                      <option>General Practice</option>
                      <option>Internal Medicine</option>
                      <option>Cardiology</option>
                      <option>Dermatology</option>
                      <option>Psychiatry</option>
                    </select>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Experience
                    </label>
                    <input
                      type="text"
                      defaultValue={mockDoctor.experience}
                      className="w-full bg-white border border-gray-300 rounded-lg px-4 py-3 text-gray-900 focus:outline-none focus:ring-2 focus:ring-teal-400"
                    />
                  </div>
                  <div className="md:col-span-2">
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Working Hours
                    </label>
                    <input
                      type="text"
                      defaultValue={mockDoctor.workingHours}
                      className="w-full bg-white border border-gray-300 rounded-lg px-4 py-3 text-gray-900 focus:outline-none focus:ring-2 focus:ring-teal-400"
                    />
                  </div>
                </div>

                <button className="mt-6 px-6 py-3 bg-teal-600 text-white rounded-lg hover:bg-teal-700 transition-colors font-medium">
                  Update Professional Info
                </button>
              </div>
            </div>

            {/* Settings Sidebar */}
            <div className="space-y-6">
              {/* Quick Stats */}
              <div className="bg-white rounded-xl p-6 border border-gray-200 shadow-sm">
                <h3 className="text-lg font-semibold text-gray-900 mb-4">
                  Quick Stats
                </h3>
                <div className="space-y-4">
                  <div className="flex items-center justify-between">
                    <div className="flex items-center">
                      <Calendar className="h-5 w-5 text-blue-500 mr-3" />
                      <span className="text-gray-700">This Month</span>
                    </div>
                    <span className="font-semibold text-gray-900">
                      24 consultations
                    </span>
                  </div>
                  <div className="flex items-center justify-between">
                    <div className="flex items-center">
                      <Users className="h-5 w-5 text-green-500 mr-3" />
                      <span className="text-gray-700">Total Patients</span>
                    </div>
                    <span className="font-semibold text-gray-900">156</span>
                  </div>
                  <div className="flex items-center justify-between">
                    <div className="flex items-center">
                      <Award className="h-5 w-5 text-yellow-500 mr-3" />
                      <span className="text-gray-700">Rating</span>
                    </div>
                    <span className="font-semibold text-gray-900">4.9/5</span>
                  </div>
                </div>
              </div>

              {/* Contact Information */}
              <div className="bg-white rounded-xl p-6 border border-gray-200 shadow-sm">
                <h3 className="text-lg font-semibold text-gray-900 mb-4">
                  Contact Info
                </h3>
                <div className="space-y-3">
                  <div className="flex items-center">
                    <Mail className="h-4 w-4 text-gray-400 mr-3" />
                    <span className="text-gray-700 text-sm">
                      {mockDoctor.email}
                    </span>
                  </div>
                  <div className="flex items-center">
                    <PhoneIcon className="h-4 w-4 text-gray-400 mr-3" />
                    <span className="text-gray-700 text-sm">
                      {mockDoctor.phone}
                    </span>
                  </div>
                </div>
              </div>

              {/* Security Settings */}
              <div className="bg-white rounded-xl p-6 border border-gray-200 shadow-sm">
                <h3 className="text-lg font-semibold text-gray-900 mb-4">
                  Security & Privacy
                </h3>
                <div className="space-y-3">
                  <button className="w-full text-left p-3 text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-lg transition-colors flex items-center">
                    <Shield className="h-4 w-4 mr-3" />
                    Change Password
                  </button>
                  <button className="w-full text-left p-3 text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-lg transition-colors flex items-center">
                    <Settings className="h-4 w-4 mr-3" />
                    Privacy Settings
                  </button>
                  <button className="w-full text-left p-3 text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-lg transition-colors flex items-center">
                    <Bell className="h-4 w-4 mr-3" />
                    Notification Preferences
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  /* -------------------------------------------------------------------- */
  /*  ⬤  MAIN COMPONENTS                                                  */
  /* -------------------------------------------------------------------- */

  // Navigation Component (updated to handle Profile click)
  const Navigation = () => (
    <nav className="bg-white border-b border-gray-200 sticky top-0 z-50 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center">
            <img src={quantumLogo} style={{ width: "200px" }} />
            <div className="hidden md:flex ml-10 space-x-4">
              {["home", "appointments"].map((page) => (
                <button
                  key={page}
                  onClick={() => setCurrentPage(page)}
                  className={`px-3 py-2 rounded-md text-sm font-medium transition-colors ${
                    currentPage === page
                      ? "bg-gray-100 text-gray-900"
                      : "text-gray-600 hover:text-gray-900 hover:bg-gray-100"
                  }`}
                >
                  {page.charAt(0).toUpperCase() + page.slice(1)}
                </button>
              ))}
            </div>
          </div>

          <div className="flex items-center space-x-4">
            {/* <button className="p-2 rounded-md text-gray-600 hover:text-gray-900 hover:bg-gray-100 relative">
              <Bell className="h-5 w-5" />
              <span className="absolute -top-1 -right-1 h-3 w-3 bg-red-500 rounded-full" />
            </button> */}
            <div className="w-32">
              <Select
                value={language}
                onValueChange={(value) => setLanguage(value)}
              >
                <SelectTrigger>
                  <SelectValue placeholder="Select language" />
                </SelectTrigger>
                <SelectContent className="w-32 bg-white">
                  <SelectItem value="en-US">English</SelectItem>
                  <SelectItem value="dh-ML">ދިވެހި</SelectItem>
                  <SelectItem value="si-SI">සිංහල</SelectItem>
                </SelectContent>
              </Select>
            </div>

            <div className="relative">
              <button
                onClick={() => setUserDropdownOpen(!userDropdownOpen)}
                className="flex items-center space-x-3 p-2 rounded-md text-gray-600 hover:text-gray-900 hover:bg-gray-100 transition-colors"
              >
                <img
                  src={doctor.avatar}
                  alt={doctor.name}
                  className="h-10 w-10 rounded-md object-cover"
                />
                <div className="hidden md:block text-left">
                  <p className="text-sm font-medium text-gray-900 leading-none">
                    {doctor.name}
                  </p>
                  <p className="text-xs text-gray-500 leading-none mt-1">
                    {doctor.specialty}
                  </p>
                </div>
                <ChevronDown className="h-4 w-4" />
              </button>

              {userDropdownOpen && (
                <div className="absolute right-0 mt-2 w-48 bg-white border border-gray-100 rounded-md shadow-lg py-1 z-50">
                  <button
                    onClick={() => {
                      setCurrentPage("profile");
                      setUserDropdownOpen(false);
                    }}
                    className="flex items-center w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                  >
                    <User className="h-4 w-4 mr-3" />
                    Profile
                  </button>
                  <button className="flex items-center w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
                    <Settings className="h-4 w-4 mr-3" />
                    Settings
                  </button>
                  {/* <hr className="my-1" />
                  <button
                    onClick={() => {
                      Navigate("/dashboardwhite");
                    }}
                    className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 w-full text-left"
                  >
                    <ArrowRight className="mr-3 h-4 w-4" />
                    Patient Dashboard
                  </button>
                  <button
                    onClick={() => {
                      Navigate("/doctordashboard");
                    }}
                    className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 w-full text-left"
                  >
                    <ArrowRight className="mr-3 h-4 w-4" />
                    Doctor Dashboard
                  </button> */}
                  <hr className="my-1" />
                  <button
                    className="flex items-center w-full px-4 py-2 text-sm text-red-600 hover:bg-gray-100"
                    onClick={() => {
                      Navigate("/");
                    }}
                  >
                    <LogOut className="h-4 w-4 mr-3" />
                    Log out
                  </button>
                </div>
              )}
            </div>

            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="md:hidden p-2 rounded-md text-gray-600 hover:text-gray-900 hover:bg-gray-100"
            >
              {isMobileMenuOpen ? (
                <X className="h-6 w-6" />
              ) : (
                <Menu className="h-6 w-6" />
              )}
            </button>
          </div>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden border-t border-gray-200 bg-gray-50">
          <div className="px-2 pt-2 pb-3 space-y-1">
            {["home", "appointments"].map((page) => (
              <button
                key={page}
                onClick={() => {
                  setCurrentPage(page);
                  setIsMobileMenuOpen(false);
                }}
                className="block w-full text-left px-3 py-2 rounded-md text-base font-medium text-gray-600 hover:text-gray-900 hover:bg-gray-100"
              >
                {page.charAt(0).toUpperCase() + page.slice(1)}
              </button>
            ))}
          </div>
        </div>
      )}
    </nav>
  );

  // Home Page Component
  const HomePage = () => {
    const [showAddPatient, setShowAddPatient] = React.useState(false);

    function handleAddPatient(patientData) {
      // add patient logic
      // e.g. setPatients(prev => [...prev, patientData]);
    }

    const upcoming = allAppointments
      .filter((a) => a.status === "upcoming")
      .slice(0, 3);

    // Timeline-style recent activity sample data
    const activities = [
      {
        id: 1,
        icon: <User className="h-5 w-5 text-teal-600" />,
        label: "Patient Ahmed has registered",
        time: "08:52 AM",
        status: "done",
      },
      {
        id: 2,
        icon: <Calendar className="h-5 w-5 text-blue-600" />,
        label: "Vitals recorded for Aisha Ibrahim",
        time: "09:15 AM",
        status: "done",
      },
      {
        id: 3,
        icon: <FileText className="h-5 w-5 text-indigo-600" />,
        label: "New lab report uploaded",
        time: "10:16 AM",
        status: "done",
      },
      {
        id: 4,
        icon: <CheckCircle2 className="h-5 w-5 text-green-600" />,
        label: "Assigned Dr. Mohamed Ali to patient Sarah Thomson",
        time: "11:20 AM",
        status: "done",
      },
    ];

    return (
      <div className="min-h-screen bg-gray-50">
        <Navigation />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          {/* Top row: greeting, button */}
          <div className="flex flex-col sm:flex-row justify-between items-center mb-8">
            <h1 className="text-3xl font-bold text-gray-900">
              Good afternoon,{" "}
              <span className="text-teal-700">{doctor.name.split(" ")[0]}</span>
            </h1>
            <div className="flex gap-4 mt-4 sm:mt-0">
              <button
                //onClick={() => setShowAddPatient(true)}
                onClick={() => setShowRegisterModal(true)}
                className="px-8 py-3 rounded-xl bg-gradient-to-r from-green-500 to-teal-600 text-white text-lg font-bold shadow-lg hover:scale-105 transition-all border-2 border-green-600"
              >
                <Plus className="inline mr-2" /> Register Patient
              </button>
              <button
                onClick={() => setShowCreateApt(true)}
                className="px-8 py-3 rounded-xl bg-gradient-to-r from-blue-500 to-indigo-600 text-white text-lg font-bold shadow-lg hover:scale-105 transition-all border-2 border-blue-600"
              >
                Create Appointment
              </button>
            </div>
          </div>

          {/* Cards: Recent appointments and activity */}
          <div className="grid lg:grid-cols-3 gap-8">
            <div className="lg:col-span-2 space-y-6">
              {/* Recent appointments */}
              <div className="bg-white rounded-xl border border-gray-200 shadow-sm">
                <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200">
                  <h2 className="text-lg font-semibold text-gray-900">
                    Recent Appointments
                  </h2>
                  <button
                    onClick={() => setCurrentPage("appointments")}
                    className="text-sm text-blue-600 hover:underline"
                  >
                    View all
                  </button>
                </div>
                <div className="divide-y divide-gray-200">
                  {upcoming.length === 0 && (
                    <p className="p-6 text-gray-500">
                      No upcoming appointments
                    </p>
                  )}
                  {upcoming?.map((apt) => (
                    <div
                      key={apt.id}
                      className="p-6 flex items-center justify-between"
                    >
                      <div className="flex items-center space-x-4">
                        <img
                          src={apt.avatar}
                          alt={apt.patient}
                          className="h-10 w-10 rounded-full object-cover"
                        />
                        <div>
                          <p className="text-gray-900 font-medium">
                            {apt.patient} | {apt.cardno}
                          </p>
                          <p className="text-sm text-gray-600">
                            {apt.date} • {apt.time}
                          </p>
                        </div>
                      </div>
                      <div className="flex items-center space-x-3">
                        {/* <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800">
                          {apt.type === "video" ? "Video" : "Chat"}
                        </span> */}
                        {/* {apt.type === "video" && (
                          <button
                            onClick={() => startVideoCall(apt)}
                            className="px-3 py-1 bg-blue-600 text-white rounded text-sm hover:bg-blue-700 transition-colors"
                          >
                            Join
                          </button>
                        )} */}
                        <button
                          onClick={() => {
                            setSelectedAppointment(apt);
                            setCurrentPage("appointmentDetails");
                          }}
                          className="text-blue-600 hover:underline text-sm"
                        >
                          View
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            {/* Recent activity timeline card */}
            <div>
              <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-6">
                <h2 className="text-lg font-semibold text-gray-900 mb-4">
                  Recent Activity
                </h2>
                <ul className="relative pl-8">
                  {activities.map((act, i) => (
                    <li
                      key={act.id}
                      className="mb-6 last:mb-0 flex items-center"
                    >
                      <span
                        style={{ zIndex: 48 }}
                        className="absolute left-0 flex items-center justify-center h-6 w-6 rounded-full bg-teal-50 ring-1 ring-teal-200"
                      >
                        {React.cloneElement(act.icon, { className: "h-4 w-4" })}
                      </span>
                      <div>
                        <span className="font-medium text-gray-800">
                          {act.label}
                        </span>
                        <span className="ml-2 text-xs text-gray-500 align-middle">
                          {act.time}
                        </span>
                      </div>
                    </li>
                  ))}
                  {/* Timeline vertical line */}
                  <span
                    className="absolute top-6 w-0.5 bg-teal-100"
                    style={{ left: 10, bottom: 9 }}
                  ></span>
                </ul>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-xl border border-gray-200 shadow mt-10 px-8 py-6">
            <h2 className="text-lg font-semibold text-gray-900 mb-4">
              Instructions to Nurse
            </h2>
            <ul className="list-disc list-inside text-gray-700 text-base space-y-2">
              <li>Verify patient identity before each assessment.</li>
              <li>Record vital parameters and medical history before tests.</li>
              <li>
                Use proper hand hygiene and device disinfection before/after
                each patient.
              </li>
              <li>
                Ensure appointment details and test readings are accurately
                updated in the patient record.
              </li>
              <li>
                Communicate any abnormal results or urgent cases to the doctor
                promptly.
              </li>
              <li>
                Assist patients with comfort and privacy during procedure.
              </li>
            </ul>
          </div>
        </div>

        {showAddPatient && (
          <AddPatientModal
            onClose={() => setShowAddPatient(false)}
            onAdd={handleAddPatient}
          />
        )}

        {showCreateApt && (
          <CreateAppointmentModal
            onClose={() => setShowCreateApt(false)}
            onAdd={handleAddPatient}
            patients={patientsArray}
            doctors={doctorsArray}
            type="create" // This will show empty patient name field
            onCreate={(newAppointment) => {
              setSelectedAppointment(newAppointment);
              setCurrentPage("appointmentDetails");
              setShowCreateApt(false);
            }}
          />
        )}

        {showRegisterModal && (
          <Register
            isOpen={showRegisterModal}
            onClose={() => setShowRegisterModal(false)}
            onBackToLogin={() => setShowRegisterModal(false)}
            screenid="nurse"
          />
        )}
      </div>
    );
  };

  // Appointments Page Component
  const AppointmentsPage = () => {
    const filtered =
      filter === "all"
        ? allAppointments
        : allAppointments.filter((a) => a.status === filter);

    return (
      <div className="min-h-screen bg-gray-50">
        <Navigation />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <div className="flex items-center justify-between mb-8">
            <h1 className="text-3xl font-bold text-gray-900">Appointments</h1>
            <div className="flex space-x-3">
              <button className="flex items-center px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300">
                <Search className="h-4 w-4 mr-2" />
                Search
              </button>
              <button className="flex items-center px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300">
                <Filter className="h-4 w-4 mr-2" />
                Filter
              </button>
              <button
                onClick={() => setShowCreateApt(true)}
                className="flex items-center px-4 py-2 rounded-lg bg-gradient-to-r from-blue-500 to-indigo-600 text-white font-bold shadow-lg hover:scale-105 transition-all border-2 border-blue-600"
              >
                Create Appointment
              </button>
            </div>
          </div>

          <div className="flex space-x-4 mb-6 overflow-x-auto">
            {[
              { label: "All", value: "all" },
              { label: "Upcoming", value: "upcoming" },
              { label: "Completed", value: "completed" },
            ]?.map((f) => (
              <button
                key={f.value}
                onClick={() => setFilter(f.value)}
                className={`px-4 py-2 rounded-lg text-sm font-medium ${
                  filter === f.value
                    ? "bg-blue-600 text-white"
                    : "bg-gray-200 text-gray-700 hover:bg-gray-300"
                }`}
              >
                {f.label}
              </button>
            ))}
          </div>

          <div className="bg-white border border-gray-200 rounded-xl shadow-sm divide-y divide-gray-200">
            {filtered.map((apt) => (
              <div
                key={apt.id}
                className="flex items-center justify-between p-6"
              >
                <div className="flex items-center space-x-4">
                  <img
                    src={apt.avatar}
                    alt={apt.patient}
                    className="h-12 w-12 rounded-full object-cover"
                  />
                  <div>
                    <p className="font-medium text-gray-900">
                      {apt.patient} | {apt.cardno}
                    </p>
                    <p className="text-sm text-gray-600">
                      {apt.date} • {apt.time}
                    </p>
                    <p className="text-xs text-gray-500 mt-1">{apt.notes}</p>
                  </div>
                </div>

                <div className="flex items-center space-x-4">
                  {/* {apt.type === "video" ? (
                    <Video className="h-5 w-5 text-blue-500" />
                  ) : (
                    <MessageCircle className="h-5 w-5 text-green-500" />
                  )} */}

                  <span
                    className={`px-2 py-1 rounded-full text-xs font-medium capitalize ${
                      apt.status === "upcoming"
                        ? "bg-green-100 text-green-800"
                        : "bg-blue-100 text-blue-800"
                    }`}
                  >
                    {apt.status}
                  </span>

                  {/* {apt.type === "video" && apt.status === "upcoming" && (
                    <button
                      onClick={() => startVideoCall(apt)}
                      className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 text-sm transition-colors"
                    >
                      Join
                    </button>
                  )} */}

                  <button
                    onClick={() => {
                      setSelectedAppointment(apt);
                      setCurrentPage("appointmentDetails");
                    }}
                    className="px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 text-sm"
                  >
                    View
                  </button>
                </div>
              </div>
            ))}

            {filtered.length === 0 && (
              <p className="p-6 text-gray-500">No appointments found.</p>
            )}
          </div>
        </div>
        {showCreateApt && (
          <CreateAppointmentModal
            onClose={() => setShowCreateApt(false)}
            patients={patientsArray}
            doctors={doctorsArray}
            type="create"
            onCreate={(newAppointment) => {
              setSelectedAppointment(newAppointment);
              setCurrentPage("appointmentDetails");
              setShowCreateApt(false);
            }}
          />
        )}
      </div>
    );
  };

  //Chat page component
  const ChatPage = () => (
    <div className="min-h-screen bg-gray-50">
      <Navigation />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid lg:grid-cols-3 gap-8">
          {/* Chat Interface */}
          <div className="lg:col-span-2">
            <div className="bg-white rounded-xl border border-gray-200 h-[600px] flex flex-col shadow-sm">
              {/* Chat Header */}
              <div className="p-6 border-b border-gray-200">
                <div className="flex items-center justify-between">
                  <div>
                    <h2 className="text-xl font-semibold text-gray-900">
                      AI Health Assistant
                    </h2>
                    <div className="flex items-center mt-1">
                      <div className="w-2 h-2 bg-green-400 rounded-full mr-2 flex-shrink-0"></div>
                      <p className="text-sm text-gray-600 leading-none">
                        Online and ready to help
                      </p>
                    </div>
                  </div>
                  {/* Step Indicator */}
                  {/* <div className="flex items-center space-x-2">
                    <div className="text-sm text-gray-600">
                      Step {currentStep} of 4
                    </div>
                    <div className="flex space-x-1">
                      {[1, 2, 3, 4].map((step) => (
                        <div
                          key={step}
                          className={`w-2 h-2 rounded-full ${
                            step <= currentStep ? "bg-teal-400" : "bg-gray-300"
                          }`}
                        />
                      ))}
                    </div>
                  </div> */}
                </div>
              </div>

              {/* Chat Messages */}
              <div className="flex-1 p-6 overflow-y-auto">
                <div className="space-y-4">
                  {/* AI Welcome Message */}
                  <div className="flex items-start space-x-3">
                    <div className="w-8 h-8 bg-teal-600 rounded-full flex items-center justify-center flex-shrink-0">
                      <MessageCircle className="h-4 w-4 text-white" />
                    </div>
                    <div className="bg-gray-100 rounded-lg p-4 max-w-md">
                      <p className="text-gray-900">
                        Hello! I'm your AI health assistant. I'll help you
                        describe your symptoms and guide you to the right care.
                        Let's start - what's bothering you today?
                      </p>
                    </div>
                  </div>

                  {/* User Messages */}
                  {chatMessages.map((message) => (
                    <div
                      key={message.id}
                      className={`flex ${
                        message.sender === "user"
                          ? "justify-end"
                          : "items-start space-x-3"
                      }`}
                    >
                      {message.sender === "ai" && (
                        <div className="w-8 h-8 bg-teal-600 rounded-full flex items-center justify-center flex-shrink-0">
                          <MessageCircle className="h-4 w-4 text-white" />
                        </div>
                      )}
                      <div
                        className={`rounded-lg p-4 max-w-md ${
                          message.sender === "user"
                            ? "bg-blue-600 text-white"
                            : "bg-gray-100 text-gray-900"
                        }`}
                      >
                        <p>{message.text}</p>
                      </div>
                    </div>
                  ))}

                  {/* Sample conversation */}
                  {chatMessages.length === 0 && (
                    <div className="text-center py-8">
                      <MessageCircle className="h-12 w-12 text-gray-400 mx-auto mb-4" />
                      <p className="text-gray-600">
                        Start by describing your symptoms...
                      </p>
                    </div>
                  )}
                </div>
              </div>

              {/* Chat Input */}
              <div className="p-6 border-t border-gray-200">
                <div className="flex space-x-3">
                  <input
                    type="text"
                    value={symptoms}
                    onChange={(e) => setSymptoms(e.target.value)}
                    placeholder="Describe your symptoms..."
                    className="flex-1 bg-white border border-gray-300 rounded-lg px-4 py-3 text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-teal-400 focus:border-transparent"
                    onKeyPress={(e) => {
                      if (e.key === "Enter" && symptoms.trim()) {
                        const newMessage = {
                          id: Date.now().toString(),
                          text: symptoms,
                          sender: "user",
                          timestamp: new Date(),
                        };
                        setChatMessages([...chatMessages, newMessage]);
                        setSymptoms("");
                        // Simulate AI response
                        setTimeout(() => {
                          const aiResponse = {
                            id: (Date.now() + 1).toString(),
                            text: "I understand you're experiencing those symptoms. Can you tell me more about when they started and how severe they are?",
                            sender: "ai",
                            timestamp: new Date(),
                          };
                          setChatMessages((prev) => [...prev, aiResponse]);
                        }, 1000);
                      }
                    }}
                  />
                  <button
                    onClick={() => {
                      if (symptoms.trim()) {
                        const newMessage = {
                          id: Date.now().toString(),
                          text: symptoms,
                          sender: "user",
                          timestamp: new Date(),
                        };
                        setChatMessages([...chatMessages, newMessage]);
                        setSymptoms("");
                      }
                    }}
                    className="bg-teal-600 hover:bg-teal-700 text-white px-6 py-3 rounded-lg transition-colors"
                  >
                    Send
                  </button>
                </div>
              </div>
            </div>

            {/* Action Buttons - UPDATED */}
            <div className="mt-6 flex flex-wrap gap-4">
              {/* <button
                onClick={startVideoCall}
                className="flex items-center px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
              >
                <Video className="h-5 w-5 mr-2" />
                Start Video Call
              </button> */}
              <button
                onClick={() => setCurrentPage("appointmentDetails")}
                className="flex items-center px-6 py-3 bg-teal-600 text-white rounded-lg hover:bg-teal-700 transition-colors"
              >
                {/* <Calendar className="h-5 w-5 mr-2" /> */}
                Back to Appointment
              </button>
              <button className="flex items-center px-6 py-3 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition-colors">
                <FileText className="h-5 w-5 mr-2" />
                Save & Exit
              </button>
            </div>
          </div>

          {/* AI Insights Sidebar */}
          <div className="space-y-6">
            {/* Live Insights */}
            {/* <div className="bg-white rounded-xl p-6 border border-gray-200 shadow-sm">
              <div className="flex items-center mb-4">
                <div className="w-3 h-3 bg-green-400 rounded-full mr-2 animate-pulse"></div>
                <h3 className="text-lg font-semibold text-gray-900">
                  AI Insights (Live)
                </h3>
              </div>

              <div className="space-y-4">
                <div>
                  <h4 className="text-sm font-medium text-gray-700 mb-2">
                    Symptom Summary
                  </h4>
                  <div className="text-sm text-gray-600">
                    {chatMessages.length > 0
                      ? "Analyzing your symptoms..."
                      : "No symptoms reported yet"}
                  </div>
                </div>

                <div>
                  <h4 className="text-sm font-medium text-gray-700 mb-2">
                    Suggested Questions
                  </h4>
                  <div className="space-y-2">
                    <div className="text-sm text-gray-600 p-2 bg-gray-100 rounded">
                      "When did the symptoms start?"
                    </div>
                    <div className="text-sm text-gray-600 p-2 bg-gray-100 rounded">
                      "How severe is the pain (1-10)?"
                    </div>
                    <div className="text-sm text-gray-600 p-2 bg-gray-100 rounded">
                      "Any recent travel or exposure?"
                    </div>
                  </div>
                </div>

                <div>
                  <h4 className="text-sm font-medium text-gray-700 mb-2">
                    Possible Conditions
                  </h4>
                  <div className="space-y-2">
                    <div className="flex items-center justify-between p-2 bg-gray-100 rounded">
                      <span className="text-sm text-gray-600">Common Cold</span>
                      <span className="text-xs bg-green-600 text-white px-2 py-1 rounded">
                        65%
                      </span>
                    </div>
                    <div className="flex items-center justify-between p-2 bg-gray-100 rounded">
                      <span className="text-sm text-gray-600">
                        Seasonal Allergies
                      </span>
                      <span className="text-xs bg-yellow-600 text-white px-2 py-1 rounded">
                        35%
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div> */}

            {/* Risk Assessment */}
            <div className="bg-white rounded-xl p-6 border border-gray-200 shadow-sm">
              <h3 className="text-lg font-semibold text-gray-900 mb-4">
                Risk Assessment
              </h3>
              <div className="flex items-center p-4 bg-blue-900/30 border border-green-700 rounded-lg">
                <Info className="h-5 w-5 text-green-400 mr-3" />
                <div>
                  <p className="text-gray-600 font-medium">Low Risk</p>
                  <p className="text-sm text-gray-600">
                    Symptoms suggest non-urgent condition
                  </p>
                </div>
              </div>
            </div>

            {/* Quick Actions */}
            <div className="bg-white rounded-xl p-6 border border-gray-200 shadow-sm">
              <h3 className="text-lg font-semibold text-gray-900 mb-4">
                Quick Actions
              </h3>
              <div className="space-y-3">
                <button className="w-full flex items-center p-3 text-left text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-lg transition-colors">
                  <Phone className="h-4 w-4 mr-3" />
                  Emergency Call
                </button>
                <button className="w-full flex items-center p-3 text-left text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-lg transition-colors">
                  <FileText className="h-4 w-4 mr-3" />
                  Medical History
                </button>
                {/* <button className="w-full flex items-center p-3 text-left text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-lg transition-colors">
                  <Users className="h-4 w-4 mr-3" />
                  Find Pharmacy
                </button> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
  // Appointment Details Page Component (UPDATED with new prescription section)
  const AppointmentDetailsPage = () => {
    const [diagnosisSummary, setDiagnosisSummary] = useState("");
    const [medicalHistory, setMedicalHistory] = useState("");
    const [showVitals, setShowVitals] = useState(false); // Controls vitals visibility
    const [isFetchingVitals, setIsFetchingVitals] = useState(false); // Loading state
    // Sample 1: Array with one mock medical record file
    const [medicalRecords, setMedicalRecords] = useState([
      {
        name: "lab_report.pdf",
        size: 242384, // bytes
        type: "application/pdf",
        lastModified: 1692279725843, // epoch ms
      },
    ]);

    const [deviceResults, setDeviceResults] = useState([
      { label: "Blood Pressure", value: "120/80", color: "green" },
      { label: "Pulse Oximetry", value: "98%", color: "blue" },
      { label: "Height", value: "172cm", color: "purple" },
      { label: "Weight", value: "70kg", color: "yellow" },
      { label: "Heart Rate", value: "78 bpm", color: "teal" },
      { label: "Body Water", value: "42L", color: "cyan" },
      { label: "Body Fat", value: "15%", color: "pink" },
      { label: "Body Age", value: "32", color: "orange" },
      { label: "Bone Mass", value: "3.2kg/m²", color: "lime" },
      { label: "Protein", value: "45g", color: "red" },
      { label: "Visceral Fat", value: "8.5", color: "violet" },
      { label: "Muscle Mass", value: "58kg", color: "fuchsia" },
      { label: "LBM", value: "10.5kg", color: "gray" },
      { label: "Obesity", value: "Class I", color: "slate" },
      { label: "BMI", value: "23.7", color: "stone" },
      { label: "Hemoglobin", value: "14.2g/dL", color: "indigo" },
      { label: "Blood Sugar", value: "95mg/dl", color: "sky" },
      { label: "Cholesterol", value: "180mg/dL", color: "amber" },
    ]);

    // Function to handle device test (renamed from existing button functionality)
    const handlePerformDeviceTest = () => {
      setIsFetchingVitals(true);
      // Simulate device test process
      setTimeout(() => {
        setShowVitals(true);
        setIsFetchingVitals(false);
      }, 2000); // 2 second delay to simulate device test
    };

    const getColorClasses = (color) => {
      const colorMap = {
        green: "from-green-100 to-green-50 text-green-700",
        blue: "from-blue-100 to-blue-50 text-blue-700",
        purple: "from-purple-100 to-purple-50 text-purple-700",
        yellow: "from-yellow-100 to-yellow-50 text-yellow-700",
        teal: "from-teal-100 to-teal-50 text-teal-700",
        cyan: "from-cyan-100 to-cyan-50 text-cyan-700",
        pink: "from-pink-100 to-pink-50 text-pink-700",
        orange: "from-orange-100 to-orange-50 text-orange-700",
        lime: "from-lime-100 to-lime-50 text-lime-700",
        red: "from-red-100 to-red-50 text-red-700",
        violet: "from-violet-100 to-violet-50 text-violet-700",
        fuchsia: "from-fuchsia-100 to-fuchsia-50 text-fuchsia-700",
        gray: "from-gray-200 to-gray-100 text-gray-700",
        slate: "from-slate-200 to-slate-100 text-slate-700",
        stone: "from-stone-200 to-stone-100 text-stone-700",
        indigo: "from-indigo-100 to-indigo-50 text-indigo-700",
        sky: "from-sky-100 to-sky-50 text-sky-700",
        amber: "from-amber-100 to-amber-50 text-amber-700",
      };
      return colorMap[color] || "from-gray-100 to-gray-50 text-gray-700";
    };

    if (!selectedAppointment) return null;

    // Handle medical record upload
    const handleFileUpload = (e) => {
      const files = Array.from(e.target.files);
      setMedicalRecords((prev) => [...prev, ...files]);
    };

    const handleRemoveFile = (index) => {
      setMedicalRecords((prev) => prev.filter((_, i) => i !== index));
    };

    const currentPatientName = selectedAppointment.patientDetails.name;
    const currentAptId = selectedAppointment.id;
    const previousAppointments = allAppointments
      .filter(
        (apt) =>
          apt.patientDetails.name === "Ahmed Hassan" && apt.id !== currentAptId
      )
      .sort((a, b) => new Date(b.date) - new Date(a.date));
    // Success Modal Component
    const AssignDoctorSuccessModal = ({ onContinue, onGoToAppointments }) => (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
        <div className="bg-white max-w-md w-full rounded-2xl shadow-2xl p-8 text-center">
          {/* Success Icon */}
          <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <Check className="h-8 w-8 text-green-600" />
          </div>

          {/* Success Message */}
          <h2 className="text-2xl font-bold text-gray-900 mb-2">
            Doctor Assigned Successfully!
          </h2>
          <p className="text-gray-600 mb-6">
            A doctor has been successfully assigned to this appointment for
            patient{" "}
            <span className="font-semibold">
              {selectedAppointment?.patient}
            </span>
            .
          </p>

          {/* Appointment Details */}
          <div className="bg-green-50 border border-green-200 rounded-lg p-4 mb-6">
            <p className="text-sm text-green-700">
              <span className="font-medium">Appointment:</span>{" "}
              {selectedAppointment?.date} • {selectedAppointment?.time}
            </p>
            <p className="text-sm text-green-700 mt-1">
              <span className="font-medium">Patient:</span>{" "}
              {selectedAppointment?.patient}
            </p>
          </div>

          {/* Action Buttons */}
          <div className="flex space-x-3">
            <button
              onClick={onContinue}
              className="flex-1 px-6 py-3 rounded-lg bg-gray-100 text-gray-700 font-semibold hover:bg-gray-200 transition-colors"
            >
              Continue
            </button>
            <button
              onClick={onGoToAppointments}
              className="flex-1 px-6 py-3 rounded-lg bg-teal-600 text-white font-semibold hover:bg-teal-700 transition-colors"
            >
              Go to Appointments
            </button>
          </div>
        </div>
      </div>
    );

    return (
      <div className="min-h-screen bg-gray-50">
        <Navigation />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <div className="flex items-center justify-between mb-8">
            <div className="flex items-center">
              <button
                onClick={() => setCurrentPage("appointments")}
                className="flex items-center text-gray-600 hover:text-gray-900 mr-4"
              >
                <ArrowLeft className="h-5 w-5 mr-2" />
                Back
              </button>
              <h1 className="text-3xl font-bold text-gray-900">
                Appointment Details
              </h1>
            </div>
            <button
              onClick={() => setShowCreateApt(true)}
              className="px-8 py-3 rounded-xl bg-gradient-to-r from-blue-500 to-indigo-600 text-white text-lg font-bold shadow-lg hover:scale-105 transition-all border-2 border-blue-600"
            >
              Assign Doctor
            </button>
          </div>

          <div className="grid lg:grid-cols-3 gap-8">
            {/* Patient details card - unchanged */}
            <div className="lg:col-span-1 space-y-6">
              <div className="bg-white rounded-xl p-6 border border-gray-200 shadow-sm">
                <div className="flex items-center mb-4">
                  <img
                    src={selectedAppointment.avatar}
                    alt={selectedAppointment.patient}
                    className="h-16 w-16 rounded-full object-cover mr-4"
                  />
                  <div>
                    <h3 className="text-xl font-semibold text-gray-900">
                      {selectedAppointment.patientDetails.name}
                    </h3>
                    <p className="text-gray-600">
                      {selectedAppointment.date} • {selectedAppointment.time}
                    </p>
                  </div>
                </div>
                <div className="space-y-3">
                  <div className="flex justify-between">
                    <span className="font-medium text-gray-700">Age:</span>
                    <span className="text-gray-900">
                      {selectedAppointment.patientDetails.age}
                    </span>
                  </div>
                  <div className="flex justify-between">
                    <span className="font-medium text-gray-700">Sex:</span>
                    <span className="text-gray-900">
                      {selectedAppointment.patientDetails.sex}
                    </span>
                  </div>
                  <div className="flex justify-between">
                    <span className="font-medium text-gray-700">Phone:</span>
                    <span className="text-gray-900">
                      {selectedAppointment.patientDetails.phone}
                    </span>
                  </div>
                  <div className="flex justify-between">
                    <span className="font-medium text-gray-700">Email:</span>
                    <span className="text-gray-900">
                      {selectedAppointment.patientDetails.email}
                    </span>
                  </div>
                  <div className="flex justify-between">
                    <span className="font-medium text-gray-700">
                      Health Card #:
                    </span>
                    <span className="text-gray-900">QCHC1234</span>
                  </div>
                </div>
              </div>

              <div className="bg-white rounded-xl p-6 border border-gray-200 shadow-sm">
                <h3 className="text-lg font-semibold text-gray-900 mb-4">
                  Previous Appointments
                </h3>

                {allAppointments.length === 0 ? (
                  <p className="text-gray-500 text-sm">
                    No previous appointments found
                  </p>
                ) : (
                  <div className="space-y-3">
                    {allAppointments.map((apt) => (
                      <div
                        key={apt.id}
                        className="p-3 border border-gray-200 rounded-lg hover:bg-blue-50 cursor-pointer transition-colors"
                        onClick={() => {
                          setSelectedAppointment(apt);
                          setCurrentPage("appointmentDetails");
                        }}
                      >
                        <div className="flex justify-between items-start mb-1">
                          <span className="font-medium text-gray-900">
                            {apt.date} • {apt.time}
                          </span>
                          <span
                            className={`px-2 py-1 rounded-full text-xs font-medium capitalize ${
                              apt.status === "completed"
                                ? "bg-blue-100 text-blue-800"
                                : "bg-green-100 text-green-800"
                            }`}
                          >
                            {apt.status}
                          </span>
                        </div>
                        <p className="text-sm text-gray-600 mb-1">
                          Type: <span className="capitalize">{apt.type}</span>
                        </p>
                        <p className="text-sm text-gray-500">{apt.notes}</p>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>

            {/* Right-side content */}
            <div className="lg:col-span-2 space-y-8">
              {/* Diagnosis Summary & Medical History */}
              <div className="bg-white rounded-xl p-6 border border-gray-200 shadow-sm space-y-6">
                <div>
                  <div className="flex items-center justify-between mb-2">
                    <label className="block text-sm font-medium text-gray-700">
                      Diagnosis Summary
                    </label>
                    <button
                      type="button"
                      className="px-4 py-1 bg-gradient-to-r from-blue-500 to-indigo-600 text-white text-sm font-semibold rounded-lg shadow hover:scale-105 transition-all"
                      onClick={() => setCurrentPage("chat")}
                    >
                      AI Assistance
                    </button>
                  </div>
                  <textarea
                    rows={3}
                    value={diagnosisSummary}
                    onChange={(e) => setDiagnosisSummary(e.target.value)}
                    className="w-full border border-gray-300 rounded-lg px-4 py-3 text-gray-900 focus:outline-none focus:ring-2 focus:ring-teal-400 focus:border-transparent resize-none"
                    placeholder="Enter summary of clinical findings, assessments, etc."
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Medical History
                  </label>
                  <textarea
                    rows={3}
                    value={medicalHistory}
                    onChange={(e) => setMedicalHistory(e.target.value)}
                    className="w-full border border-gray-300 rounded-lg px-4 py-3 text-gray-900 focus:outline-none focus:ring-2 focus:ring-teal-400 focus:border-transparent resize-none"
                    placeholder="Provide relevant medical and surgical history, allergies, etc."
                  />
                </div>
              </div>

              {/* Device Test and Vitals Display */}
              <div className="bg-white rounded-xl p-6 border border-gray-200 shadow-sm space-y-6">
                <div className="flex items-center justify-between mb-2">
                  <span className="font-semibold text-lg text-gray-900">
                    Integrated Device Results & Uploaded Vitals
                  </span>
                </div>

                {/* Single button that handles device test */}
                <button
                  type="button"
                  className={`inline-flex items-center px-5 py-2 rounded-lg font-semibold transition-colors ${
                    isFetchingVitals
                      ? "bg-gray-400 text-white cursor-not-allowed"
                      : showVitals
                      ? "bg-green-600 text-white"
                      : "bg-blue-600 text-white hover:bg-blue-700"
                  }`}
                  onClick={handlePerformDeviceTest}
                  disabled={isFetchingVitals}
                >
                  {isFetchingVitals ? (
                    <>
                      <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                      Performing Device Test...
                    </>
                  ) : showVitals ? (
                    <>
                      <Check className="h-4 w-4 mr-2" />
                      Device Test Completed
                    </>
                  ) : (
                    "Perform Device Test (Demo Mode)"
                  )}
                </button>

                {/* Show loading state */}
                {isFetchingVitals && (
                  <div className="flex items-center justify-center py-12">
                    <div className="text-center">
                      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
                      <p className="text-gray-600">
                        Running diagnostic tests...
                      </p>
                      <p className="text-gray-500 text-sm mt-2">
                        Connecting to integrated medical devices
                      </p>
                    </div>
                  </div>
                )}

                {/* Show vitals results only after device test is complete */}
                {showVitals && !isFetchingVitals && (
                  <div className="space-y-4 animate-fadeIn">
                    <div className="p-3 bg-green-50 border border-green-200 rounded-lg">
                      <p className="text-sm text-green-700 font-medium">
                        ✓ Device test completed successfully! Retrieved{" "}
                        {deviceResults.length} vital parameters.
                      </p>
                    </div>

                    {/* Split results into rows of 5 */}
                    {Array.from(
                      { length: Math.ceil(deviceResults.length / 5) },
                      (_, rowIndex) => (
                        <div
                          key={rowIndex}
                          className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3 py-2"
                        >
                          {deviceResults
                            .slice(rowIndex * 5, rowIndex * 5 + 5)
                            .map((item, idx) => (
                              <div
                                key={idx}
                                className={`rounded-md bg-gradient-to-br ${getColorClasses(
                                  item.color
                                )} p-3 shadow max-w-[140px] break-words text-center transform hover:scale-105 transition-transform duration-200`}
                              >
                                <p className="text-sm font-bold break-words">
                                  {item.value}
                                </p>
                                <p className="text-xs text-gray-500 mt-1 break-words">
                                  {item.label}
                                </p>
                              </div>
                            ))}
                        </div>
                      )
                    )}
                  </div>
                )}

                {/* Show placeholder when no vitals are displayed */}
                {!showVitals && !isFetchingVitals && (
                  <div className="flex items-center justify-center py-8 border-2 border-dashed border-gray-300 rounded-lg">
                    <div className="text-center">
                      {/* <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
                        <span className="text-2xl">🩺</span>
                      </div> */}
                      <p className="text-gray-500 font-medium mb-2">
                        No Device Test Results
                      </p>
                      <p className="text-gray-400 text-sm">
                        Click "Perform Device Test" to run diagnostics
                      </p>
                    </div>
                  </div>
                )}
              </div>

              {/* Medical Record Documents */}
              <div className="bg-white rounded-xl p-6 border border-gray-200 shadow-sm space-y-6">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Medical Records
                </label>
                <input
                  type="file"
                  multiple
                  onChange={handleFileUpload}
                  className="block mb-3"
                />
                {medicalRecords.length > 0 && (
                  <ul className="space-y-2">
                    {medicalRecords.map((file, i) => (
                      <li key={i} className="flex items-center justify-between">
                        <span className="text-gray-700 text-sm">
                          {file.name}
                        </span>
                        <button
                          className="text-red-600 text-xs ml-2"
                          onClick={() => handleRemoveFile(i)}
                          type="button"
                        >
                          Remove
                        </button>
                      </li>
                    ))}
                  </ul>
                )}
              </div>

              <div className="flex justify-end space-x-4 pt-6 border-t border-gray-200">
                <button
                  onClick={() => setCurrentPage("appointments")}
                  className="px-6 py-3 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition-colors font-medium"
                >
                  Cancel
                </button>
                <button
                  onClick={() => setCurrentPage("appointments")}
                  className="flex items-center px-6 py-3 bg-teal-600 text-white rounded-lg hover:bg-teal-700 transition-colors font-medium"
                >
                  <Save className="h-4 w-4 mr-2" />
                  Save Notes & Prescription
                </button>
              </div>
            </div>
          </div>
        </div>
        {showCreateApt && (
          <CreateAppointmentModal
            onClose={() => setShowCreateApt(false)}
            patients={patientsArray}
            doctors={doctorsArray}
            type="assign" // This will auto-fill patient name
            selectedAppointment={selectedAppointment} // Pass the selected appointment
            onCreate={() => {
              setShowCreateApt(false);
            }}
          />
        )}
        {showAssignSuccess && (
          <AssignDoctorSuccessModal
            onContinue={() => {
              setShowAssignSuccess(false); // Just close the modal, stay on current page
            }}
            onGoToAppointments={() => {
              setShowAssignSuccess(false); // Close the modal
              setCurrentPage("appointments"); // Navigate to appointments page
            }}
          />
        )}
      </div>
    );
  };

  // Render Page Logic
  const renderPage = () => {
    if (isInWaitingRoom)
      return <WaitingRoomPage onJoin={handleJoinVideoCall} />;
    if (isOnVideoCall) return <VideoCallPage onEndCall={handleEndCall} />;
    if (callEnded) return <CallEndedPage onClose={handleCallEndedClose} />;

    switch (currentPage) {
      case "home":
        return <HomePage />;
      case "appointments":
        return <AppointmentsPage />;
      case "chat":
        return <ChatPage />;
      case "appointmentDetails":
        return <AppointmentDetailsPage />;
      case "profile":
        return <ProfilePage />;
      default:
        return <HomePage />;
    }
  };

  return <>{renderPage()}</>;
}

export default NurseDashboard;
